import React, { useMemo } from 'react';
import TrustPilotRating from '@justpark/ui/src/components/TrustPilotRating';
import { useTranslation } from 'react-i18next';
import useDarkly from '../hooks/useDarkly';

type Props = {
  isFlat?: boolean,
  isCompact?: boolean,
  isLight?: boolean
};
const ConnectedTrustPilotRating = ({ isFlat, isCompact, isLight }: Props) => {
  const { t } = useTranslation();
  const trustPilotScore = useDarkly('trustpilot-data');

  const data = trustPilotScore || {};
  const { rating = 4.6, reviewCount = 77640 } = data;

  const count = useMemo(() => {
    const lowestThousand = 1000 * Math.floor(reviewCount / 1000);

    try {
      return new Intl.NumberFormat('en-GB').format(lowestThousand);
    } catch {
      return lowestThousand;
    }
  }, [reviewCount]);

  const subtextNormal = 'ui:trustpilot-tagline';
  const subtextShort = 'ui:trustpilot-taglineShort';

  const subtext = t(isFlat ? subtextShort : subtextNormal, {
    count
  });

  return (
    <TrustPilotRating
      subtext={subtext}
      rating={rating}
      isFlat={isFlat}
      isCompact={isCompact}
      isLight={isLight}
    />
  );
};

export default ConnectedTrustPilotRating;
